module.exports = __webpack_public_path__ + "assets/img/HH_Continuum_RGB_lr.10f9e62e.jpg";